import React from 'react';
import { Alert } from '@instructure/ui-alerts';



export const FullscreenErrorAlert = ({ dispatch, err }) => {
  return (
    <Alert variant="info"
           margin="small"
           renderCloseButtonLabel="Close"
           onDismiss={ () => dispatch(dismissErrorAction()) } >

      {messageForError(err)}

    </Alert>
  );
};



const messageForError = err => {
  if (err.whileExiting) {
    return (
      <span>
        We were unable to exit full screen mode automatically.
        Please try pressing the <i>escape</i> key to exit,
        or use your browser’s controls.
      </span>
    );

  } else {
    return (
      <span>
        We were unable to enter full screen mode automatically.
        Please try using your browser’s controls to go full screen.
      </span>
    );
  }
};



const dismissErrorAction = () => ({
  type: 'DISMISS_FULLSCREEN_ERROR',
  payload: null
});
